export default function getSlug({ params, searchParams }) {
    let url = "";
    // Handle the path segments (just like before)
    if (Array.isArray(params === null || params === void 0 ? void 0 : params.slug)) {
        url = params === null || params === void 0 ? void 0 : params.slug.filter((segment) => segment !== "favicon.ico").join("/");
    }
    else if (typeof (params === null || params === void 0 ? void 0 : params.slug) === "string" &&
        (params === null || params === void 0 ? void 0 : params.slug) !== "favicon.ico") {
        url = params === null || params === void 0 ? void 0 : params.slug;
    }
    // If we also have searchParams, convert them to a query string
    if (searchParams && Object.keys(searchParams).length > 0) {
        const qs = new URLSearchParams();
        for (const key in searchParams) {
            const val = searchParams[key];
            if (Array.isArray(val)) {
                val.forEach((v) => qs.append(key, v));
            }
            else if (typeof val === "string") {
                qs.append(key, val);
            }
            // if undefined or null, skip
        }
        const queryString = qs.toString(); // e.g. "type=news&term=lebanon"
        if (queryString) {
            url += `?${queryString}`;
        }
    }
    return url;
}
